export default __webpack_public_path__ + "static/yakuodo-cd69df5fbc6f014671d10b284e943873.png";